import { createSlice } from '@reduxjs/toolkit'

import { ContactUsModalStateType } from './types'

const initialState: ContactUsModalStateType = {
  isOpen: false,
}

const ContactUsModalSlice = createSlice({
  name: 'ContactUsModal',
  initialState,
  reducers: {
    toggleContactUsModal(state) {
      state.isOpen = !state.isOpen
    },
    closeContactUsModal(state) {
      state.isOpen = false
    },
  },
})

const ContactUsModalReducer = ContactUsModalSlice.reducer

export const { toggleContactUsModal, closeContactUsModal } = ContactUsModalSlice.actions
export default ContactUsModalReducer
